export enum Step {
  START = 'Start',
  CHOOSE_FACEBOOK_ADS_ACCOUNT = 'Choose Facebook Ads Account',
  FILL_YOUR_INFO = 'Fill Your Info',
  FILL_BUSINESS_INFO = 'Fill Business Info'
}
